<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="clearfix flex justify-between">
            <span>我的小区</span>
            <div class="float-right">
              <el-button type="primary" size="small" @click="_openEnterCommunityModal()">
                <i class="el-icon-plus"></i>
                入驻小区
              </el-button>
            </div>
          </div>

          <el-table
            :data="communityInfo.enterCommunityInfo"
            style="width: 100%"
            border
            stripe
          >
            <el-table-column prop="provName" label="省份"></el-table-column>
            <el-table-column prop="cityName" label="市/州"></el-table-column>
            <el-table-column prop="areaName" label="县/区" width="150"></el-table-column>
            <el-table-column prop="name" label="小区名称" width="200"></el-table-column>
            <el-table-column prop="communityId" label="小区编码"></el-table-column>
            <el-table-column prop="tel" label="联系方式"></el-table-column>
            <el-table-column prop="communityArea" label="面积"></el-table-column>
            <el-table-column label="状态">
              <template slot-scope="scope">
                {{_showCommunityStatus(scope.row.auditStatusCd)}}
              </template>
            </el-table-column>
            <el-table-column label="操作" align="right">
              <template slot-scope="scope">
                <el-button-group>
                  <el-button 
                    v-if="scope.row.auditStatusCd == '1100' && scope.row.communityId != '7020181217000001'"
                    size="mini" 
                    @click="_openExitCommunityModel(scope.row)"
                  >
                    申请退出
                  </el-button>
                  <el-button 
                    v-if="scope.row.auditStatusCd == '1100'"
                    size="mini" 
                    @click="_openUpdateCommunityModel(scope.row)"
                  >
                    修改面积
                  </el-button>
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            class="float-right"
            layout="prev, pager, next"
            :total="100"
          ></el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <store-enter-community ref="storeEnterCommunity"></store-enter-community>
    <store-exit-community ref="storeExitCommunity"></store-exit-community>
    <edit-community-area ref="editCommunityArea"></edit-community-area>
  </div>
</template>

<script>
import { listMyCommunity } from '@/api/common/enterCommunity/enterCommunityApi'
import StoreEnterCommunity from '@/components/common/storeEnterCommunity/storeEnterCommunity'
import StoreExitCommunity from '@/components/common/storeExitCommunity/storeExitCommunity'
import EditCommunityArea from '@/components/common/editCommunityArea/editCommunityArea'

export default {
  name: 'EnterCommunity',
  components: {
    StoreEnterCommunity,
    StoreExitCommunity,
    EditCommunityArea
  },
  data() {
    return {
      communityInfo: {
        enterCommunityInfo: []
      }
    }
  },
  created() {
    this.listMyCommunity()
  },
  methods: {
    async listMyCommunity() {
      try {
        const res = await listMyCommunity({})
        this.communityInfo.enterCommunityInfo = res
      } catch (error) {
        console.error('获取小区列表失败:', error)
      }
    },
    _openEnterCommunityModal() {
      this.$refs.storeEnterCommunity.open()
    },
    _openExitCommunityModel(community) {
      this.$refs.storeExitCommunity.open(community)
    },
    _openUpdateCommunityModel(community) {
      this.$refs.editCommunityArea.open(community)
    },
    _showCommunityStatus(_statusCd) {
      if (_statusCd == '1000') {
        return "入驻审核"
      } else if (_statusCd == '1200') {
        return "入驻失败"
      } else if (_statusCd == '1100') {
        return "入驻成功"
      }
      return "未知"
    }
  }
}
</script>

<style scoped>
.float-right {
  float: right;
}
.clearfix:after {
  content: "";
  display: table;
  clear: both;
}
</style>